import React from "react";
import "./SingleSelectedLabel.scss";

import classNames from "classnames";
import { ReactComponent as CrossBlueIcon } from "src/images/cross-blue.svg";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export function SingleSelectedLabel({
  value,
  onRemove,
  translative,
  getFullObject,
  disabled,
  hideRemove,
  isDataFilterNameFromValue,
  getCustomLabel,
}) {
  const dataFilterAttribute =
    isDataFilterNameFromValue && typeof value === "string"
      ? `${value.toLowerCase().split(" ")[0]}_selected`
      : "paid_post_performance";

  const label = getCustomLabel ? getCustomLabel(value) : value;

  return (
    <div
      className={classNames(
        "select-tags__selected-labels__single text-h7-regular",
        {
          "select-tags__selected-labels__single--disabled":
            disabled || hideRemove,
        },
      )}
      data-filter-name={dataFilterAttribute}
      onClick={hideRemove ? undefined : onRemove}
    >
      {translative ? (
        <IDHFormattedMessage
          id={getFullObject(value)?.name}
          defaultMessage={getFullObject(value)?.value}
        />
      ) : (
        label
      )}
      {!hideRemove && (
        <CrossBlueIcon className="select-tags__selected-labels__single__close" />
      )}
    </div>
  );
}
